// Modules
import React from 'react';
import store from '../store';
import {connect} from 'react-redux';
import {getMatchResultsAsync} from '../actions/history';
// Comps & Styling
import HistoryMatch from './historyMatch';

export class history extends React.Component{
    componentDidMount(){
        let scoreHistoryPayload={
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json"
            },
            method: 'GET'
        };
        store.dispatch(getMatchResultsAsync(scoreHistoryPayload, store.getState().user.uuid));
    }

    render(){
        let pastMatches=this.props.history;
        let matches=[];

        pastMatches.forEach((obj, index)=>{
            console.log(obj.title);

            matches.push(<HistoryMatch
                title={obj.title}
                location={obj.location}
                date={`${obj.date[0]}/${obj.date[1]}/${obj.date[2]}`}
                roster={obj.roster}
                key={index}
            />);
        });

        return(
            <div id="container-history" style={{textAlign: "center"}}>
                <div className="menuWrapper">
                    <h3 style={{"paddingTop": "1rem"}}>History</h3>
                    {matches}
                </div>
            </div>
        );
    }
}

const mapPropsToState = state =>({
    history: state.history.history
});

export default connect(mapPropsToState)(history);
export {history as HistoryPure};



// WEBPACK FOOTER //
// ./src/comps/history.js